import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CompanyModel } from './_models/Company/CompanyModel';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  companyChanged = new Subject<any>();
  private company: CompanyModel = {};

  constructor() { }

  getCompany() {
    return this.company;
  }

  getCompanyId(){
    const parsedJSON = JSON.parse(localStorage.getItem('userData') as string);
   return parsedJSON.companyId;

  }

  setCompany(company: CompanyModel) {
    this.company = company;
    this.companyChanged.next(this.company)
  }
}
